import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, CheckCircle2, Clock, Star } from 'lucide-react';
import { scrollToPricing } from './utils';
export function Hero() {
  return <section className="relative bg-[#1e293b] overflow-hidden" data-id="element-59">
      {/* Subtle radial glow behind the image */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a017]/8 rounded-full blur-[120px] pointer-events-none" data-id="element-60"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-5 pt-10 pb-0 flex flex-col items-center text-center" data-id="element-61">
        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-3xl md:text-5xl font-black tracking-tight leading-tight mb-8" data-id="element-62">
          <span className="text-white" data-id="element-63">TODO TU AÑO DE </span>
          <span className="text-[#d4a017]" data-id="element-64">SIC</span>
          <span className="text-white" data-id="element-65"> RESUELTO</span>
        </motion.h1>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative cursor-pointer group w-[70%] max-w-xs mb-8" onClick={scrollToPricing} data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/9Hd7zZNhSDAwCPGwx23icd/Cover_sic_mockup.png" alt="SIC 360 Sistema Completo" className="w-full drop-shadow-[0_20px_60px_rgba(212,160,23,0.15)] transform group-hover:scale-[1.03] transition-transform duration-500" data-id="element-67" />
        </motion.div>

        {/* Tagline */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-white text-xl md:text-2xl font-semibold leading-snug mb-4 max-w-lg" data-id="element-68">
          El sistema más completo de actividades, proyectos y evaluaciones
          listos para usar — con resolucionario incluido.
        </motion.p>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-slate-400 text-base md:text-lg mb-10" data-id="element-69">
          Todo el año de SIC I y SIC II resuelto. Sin planificar nada desde
          cero.
        </motion.p>

        {/* CTA Button */}
        <motion.button initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} onClick={scrollToPricing} className="w-full max-w-sm bg-[#d4a017] hover:bg-[#b88a14] text-[#0f172a] font-bold text-lg py-4 px-8 rounded-xl shadow-lg shadow-[#d4a017]/20 hover:shadow-xl hover:shadow-[#d4a017]/30 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-70">
          👉 Quiero acceso inmediato
        </motion.button>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.65
      }} className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[11px] text-slate-300 font-medium" data-id="element-71">
          <span className="flex items-center gap-1" data-id="element-72">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1" data-id="element-73">⚡ Descarga inmediata</span>
          <span className="flex items-center gap-1" data-id="element-74">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1" data-id="element-75">🔒 Acceso de por vida</span>
        </motion.div>

        {/* Stats Row - 2x2 grid */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="mt-5 pt-5 border-t border-white/10 w-full grid grid-cols-2 gap-x-6 gap-y-3" data-id="element-76">
          <div className="flex flex-col items-center" data-id="element-77">
            <span className="text-white font-extrabold text-xl md:text-2xl" data-id="element-78">
              +1.200 ⭐
            </span>
            <span className="text-slate-400 text-[9px] md:text-[10px] uppercase tracking-wider font-semibold" data-id="element-79">
              Docentes ya lo usan
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-80">
            <span className="text-white font-extrabold text-xl md:text-2xl" data-id="element-81">
              4.9/5 ⭐
            </span>
            <span className="text-slate-400 text-[9px] md:text-[10px] uppercase tracking-wider font-semibold" data-id="element-82">
              Valoración promedio
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-83">
            <span className="text-white font-extrabold text-xl md:text-2xl" data-id="element-84">
              +6 Tomos
            </span>
            <span className="text-slate-400 text-[9px] md:text-[10px] uppercase tracking-wider font-semibold" data-id="element-85">
              De contenido profesional
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-86">
            <span className="text-white font-extrabold text-xl md:text-2xl" data-id="element-87">
              #1
            </span>
            <span className="text-slate-400 text-[9px] md:text-[10px] uppercase tracking-wider font-semibold" data-id="element-88">
              Sistema elegido en Argentina
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}